"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.project.manage': '管理项目',
    'knowledge.project.none': '无项目',
};
